import {Injectable} from '@angular/core';

export enum ProjectLevel {

  Project = 0,
  Questionnaire = 1,
  Terminal = 2,
  File = 3
}

@Injectable()
export class  ProjectLevelUtil {

  constructor() {}
  static getLevel(lvl:string):ProjectLevel {
    switch(lvl) {
      case 'project': return ProjectLevel.Project;
      case 'questionnaire': return ProjectLevel.Questionnaire;
      case 'terminal':return ProjectLevel.Terminal;
      case 'file':return ProjectLevel.File;
    }

  }

}


